/**
 * URL Utils
 */

import queryString from 'query-string';

export * from 'query-string';

export const parametise = (parameters: {} = {}): string =>
    queryString.stringify(parameters, {
        skipEmptyString: true,
    });


export const getQuery = (url = window.location.search): Record<string, any> => queryString.parse(url);

export const updateUrl = (url = ''): void => window.history.pushState('', '', `?${url}`);

export const parseQuery = (uri = ''): {} => queryString.parseUrl(uri);

export const extractQuery = (uri = ''): string => queryString.extract(uri);

// TODO: see if query-string can be used to do this
export const getQueryStringUrl = (url: string, skipQuery: string): string => {
    if (skipQuery) {
        const queryIndex = url.indexOf('?');
        if (queryIndex > -1) {
            const existingQuery = url.slice(queryIndex).indexOf('=');
            return existingQuery > -1 ? `${url}&${skipQuery}` : `${url}${skipQuery}`;
        } else {
            return `${url}?${skipQuery}`;
        }
    } else {
        return url;
    }
};

export const removeQueryString = (url: string): string => {
    if (url.includes('?')) {
        const queryIndex = url.indexOf('?');
        return url.slice(0, queryIndex);
    } else {
        return url;
    }
};

export const generateQueryString = (object: any): string => {
    for (const key in object) {
        if (typeof object[key] === 'object') {
            object[key] = JSON.stringify(object[key]);
        }
    }

    return new URLSearchParams(object as Record<string, string>).toString();
};

export const generateUrlWithQuery = (baseUrl: string, queryParameters: object) => {
    const queryString = generateQueryString(queryParameters);
    return `${baseUrl}${baseUrl.includes("?") ? "&" : "?"}${queryString}`;
}
